import LandingPage from './pages/LandingPage/LandingPage';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import React from 'react';
import Footer from './components/layout/Footer';
import HeaderNavBar from './components/layout/HeaderNavBar';
import DashNavBar from './components/layout/DashNavBar';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import QuienesSomos from './pages/QuienesSomos';
import Especialidades from './pages/Especialidades';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { useStateHydration } from './redux/hooks';
import securityConfig from './utils/securityConfig';

function AppRoutes() {
  const location = useLocation();

  // Inicializar estado desde localStorage - con protección contra loops
  useStateHydration();

  // Determinar si mostrar HeaderNavBar o DashNavBar
  const authPages = ['/login', '/signup'];
  const dashboardPages = ['/dashboard'];
  const showHeaderNavBar =
    !authPages.includes(location.pathname) && !dashboardPages.includes(location.pathname);
  const showDashNavBar = dashboardPages.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {showHeaderNavBar && <HeaderNavBar />}
      {showDashNavBar && <DashNavBar />}
      <Routes>
        <Route path="/" element={<LandingPage key={location.pathname} />} />
        <Route path="/quienesomos" element={<QuienesSomos />} />
        <Route path="/especialidades" element={<Especialidades />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />

        {/* Ruta protegida unificada para dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      {showHeaderNavBar && <Footer />}
    </>
  );
}

function App() {
  // Inicializar configuración de seguridad
  React.useEffect(() => {
    securityConfig.initialize();
  }, []);

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
